import FullWidthLayout from "@/layouts/FullWidthLayout";
import KCalendar from "kinnect-front/KCalendar/KCalendar";
import { Pageable } from "kinnect-mixins";

export default {
	name: "CalendarPage",

	metaInfo: { title: "Calendar" },

	mixins: [ Pageable ],

	render() {
		return <FullWidthLayout>
			<KCalendar></KCalendar>
		</FullWidthLayout>;
	}
};
